(function () {
    var XsollaAnalytics = function (params) {
        var Config = {
            counterId: 0,
            clientId: 0,
            visitId: 0,
            siteDomains: null,
            server: "",
            hitUrl: "",
            userParamsUrl: "",
            externalId: null,
            extraValues: "",
            hit: true,
            extLink: true,
            click: true,
            scroll: true,
            sendLoadMetrics: false,
            abParams: "",
            isBrowser: (typeof window !== 'undefined'),
            hitCount: 0
        };
        var ScrollTimer = null;
        var ScrollFirst = false;
        var ScrollMiddle = false;
        var ScrollBottom = false;
        var LCP = 0;
        var firstHiddenTime = 0;
        Config.isBrowser && (firstHiddenTime = document.visibilityState === 'hidden' ? 0 : Infinity);

        var Util = {
            isArray: function (a) {
                return "function" === typeof Array.isArray ? Array.isArray(a) : "[object Array]" === Object.prototype.toString.call(a)
            },
            isString: function (a) {
                return "[object String]" === Object.prototype.toString.call(a)
            },
            random: function (a, b) {
                2 > arguments.length && (b = a, a = 0);
                1 > arguments.length && (b = 1073741824);
                return Math.floor(Math.random() * (b - a)) + a
            },
            mergeObjects: function (obj, src) {
                for (var key in src) {
                    if (src.hasOwnProperty(key)) obj[key] = src[key];
                }
                return obj;
            },
            apiHelper: function (eventType, obj) {
                if (eventType != 2) {
                    ScrollFirst = false;
                    ScrollMiddle = false;
                    ScrollBottom = false;
                }
                var externalId = obj && obj.eid ? obj.eid : Config.externalId;
                var exv = obj && obj.exv ? JSON.stringify(obj.exv) : Config.extraValues;
                var abParams = obj && typeof obj.abParams === 'object' ? JSON.stringify(obj.abParams) : Config.abParams;
                var data = {
                    et: eventType,
                    eid: externalId
                };
                if (exv) {
                    data.exv = exv;
                }
                if (abParams) {
                    data.abParams = abParams;
                }
                if (typeof obj != "object") {
                    obj = {}
                }
                obj = Util.mergeObjects(obj, data);
                return obj;
            },
            parseData: function (data) {
                if (typeof data === "object") {
                    return data;
                }
                try {
                    return JSON.parse(data);
                } catch (e) {
                    return {};
                }
            },
            getHrefWithAnchor: function (href, newParam, separator) {
                var splitHref = href.split('/');
                var anchorExists = splitHref[splitHref.length - 1].indexOf('#') !== -1;
                if (anchorExists) {
                    var splitAnchor = splitHref[splitHref.length - 1].split('#');
                    return splitHref.slice(0, -1).join('/') + '/' + splitAnchor[0] + separator + newParam + '#' + splitAnchor[1];
                }
                return href + separator + newParam;
            }
        };
        var Browser = {
            firstContentfulPaintTime: function () {
                if (firstHiddenTime === 0) {
                    return null
                }
                var FCP = 0;
                if (window.performance && window.performance.getEntriesByType) {
                    var paints = window.performance.getEntriesByType('paint');
                    for (var i = 0; i < paints.length; i++) {
                        if ("first-contentful-paint" === paints[i].name) {
                            FCP = Math.round(paints[i].startTime);
                            return FCP < firstHiddenTime ? FCP : null;
                        }
                    }
                    return null;
                }
                if ("object" === typeof window.chrome && window.chrome.loadTimes) {
                    var a = window.chrome.loadTimes();
                    if (a.requestTime && a.firstPaintTime && window.performance && window.performance.timing) {
                        FCP = Math.round(1E3 * a.firstPaintTime - window.performance.timing.navigationStart)
                        return FCP < firstHiddenTime ? FCP : null;
                    }
                } else if (window.performance && window.performance.timing && (a = window.performance.timing,
                a.navigationStart && a.msFirstPaint)) {
                    FCP = a.msFirstPaint - a.navigationStart;
                    return FCP < firstHiddenTime ? FCP : null;
                }
                return null
            },
            largestContentfulPaintTime: function () {
                try {
                    function updateLCP(entry) {
                        if (entry.startTime < firstHiddenTime) {
                            LCP = Math.round(entry.startTime);
                            // отправить LCP для страниц без скролла
                            if (Config.sendLoadMetrics) {
                                var scrollHeight = document.documentElement.scrollHeight || 0;
                                var pageHeight = document.documentElement.clientHeight || 0;
                                if (pageHeight >= scrollHeight) {
                                    Api.eventForLCP();
                                }
                            }
                        }
                    }

                    var po = new PerformanceObserver(function (entryList) {
                        var entries = entryList.getEntries();
                        for (var i = 0; i < entries.length; i++) {
                            updateLCP(entries[i]);
                        }
                    });
                    po.observe({type: 'largest-contentful-paint', buffered: true});

                    document.addEventListener('visibilitychange', function f() {
                        if (document.visibilityState === 'hidden') {
                            document.removeEventListener('visibilitychange', f, true);
                            var rec = [];
                            if (po.takeRecords) {
                                rec = po.takeRecords();
                            }
                            for (var i = 0; i < rec.length; i++) {
                                updateLCP(rec[i], po);
                            }
                            po.disconnect();
                        }
                    }, true);
                } catch (e) {
                }
            },
            netType: function () {
                var a = (navigator.connection || {type: ""}).type;
                return a === undefined ? "" : a
            },
            getLanguage: function () {
                var a = (window.navigator ? navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage : "").toLowerCase();
                return Util.isString(a) ? a : ""
            },
            getJavaEnabled: function () {
                try {
                    return navigator.javaEnabled()
                } catch (a) {
                    return !1
                }
            },
            getNotificationPermission: function () {
                try {
                    var a = Notification.permission
                } catch (b) {
                }
                switch (a) {
                    case "denied":
                        return 0;
                    case "granted":
                        return 1
                }
            },
            isIframe: function () {
                try {
                    return window.top !== window.self
                } catch (a) {
                    return !1
                }
            },
            getCookiesEnabled: function () {
                if (navigator.cookieEnabled) return true;
                // set and read cookie
                document.cookie = "cookietest=1";
                var ret = document.cookie.indexOf("cookietest=") !== -1;
                // delete cookie
                document.cookie = "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT";
                return ret;
            },
        };

        var Time = {
            getSeconds: function () {
                return Math.round(+new Date / 1E3)
            },
            getTimezone: function () {
                return -(new Date).getTimezoneOffset()
            }
        };

        var Cookies = {
            getVid: function () {
                if (Config.visitId !== 0) {
                    return Config.visitId;
                }
                var generateNew = Document.isFromAd();
                var vid = generateNew ? 0 : this.readM("vid");

                if (!vid) {
                    vid = Time.getSeconds() + "" + Util.random();
                }
                this.create("vid", vid, 30);

                return vid;
            },
            getUid: function () {
                this.globalDomain();
                var uid = this.readM("uid");
                var uidLS = this.readLocalStorage("uid");

                if (!uid && !uidLS) {
                    uid = Time.getSeconds() + "" + Util.random();
                    this.create("uid", uid, 1036800);
                    this.createLocalStorage("uid", uid);
                } else if (!uid && uidLS) {
                    uid = uidLS;
                    this.create("uid", uidLS, 1036800);
                } else if (uid && !uidLS) {
                    this.createLocalStorage("uid", uid);
                }
                return uid;
            },
            getXsollauid: function (id) {
                this.globalDomain();
                var xid = this.readM("xsollauid");
                var xidLS = this.readLocalStorage("xsollauid");

                if (!id) {
                    if (xid && !xidLS) {
                        this.createLocalStorage("xsollauid", xid);
                    } else if (!xid && xidLS) {
                        this.create("xsollauid", xidLS, 5184000);
                    }
                    return xid || xidLS;
                }

                this.create("xsollauid", id, 5184000);
                this.createLocalStorage("xsollauid", id);

                return id;
            },
            createLocalStorage: function (name, value) {
                try {
                    localStorage.setItem(this._prepareName(name), encodeURIComponent(value));
                } catch (e) {
                }
            },

            create: function (name, value, minutes) {
                var b, a = [this._prepareName(name) + "\x3d" + encodeURIComponent(value)];
                minutes && (b = new Date, b.setTime(b.getTime() + 6E4 * minutes), a.push("expires\x3d" + b.toGMTString()));
                this._domain && a.push("domain\x3d" + this._domain);
                a.push("path\x3d/");
                a.push("SameSite\x3dNone;Secure");
                try {
                    document.cookie = a.join(";")
                } catch (d) {
                }
            },
            globalDomain: function () {
                this._domain = Document.extractHostname(window.location.host);
                return this._domain
            },
            readM: function (name) {
                name = this._prepareName(name);
                return this.read(name)
            },
            read: function (name) {
                try {
                    var b = document.cookie
                } catch (c) {
                }
                return b && b.match(new RegExp("(?:^|;\\s*)" + name + "\x3d([^;]*)")) ? decodeURIComponent(RegExp.$1) : null
            },
            readLocalStorage: function (name) {
                name = this._prepareName(name);
                try {
                    return localStorage.getItem(name);
                } catch (d) {
                    return null;
                }
            },
            erase: function (name) {
                this.create(name, "", -1)
            },
            _prepareName: function (name) {
                if (name === 'xsollauid') {
                    return name
                }
                return "_mm_" + name + (Config.counterId ? "_" + Config.counterId : "")
            }
        };

        var Document = {
            getDocumentCharset: function () {
                return ("" + (document.characterSet || document.charset || "")).toLowerCase()
            },
            getRootElement: function () {
                var a = document.documentElement;
                return "CSS1Compat" === document.compatMode ? a : document.body || a
            },
            getViewportSize: function () {
                var a = this.getRootElement();
                return [a.clientWidth || window.innerWidth, a.clientHeight || window.innerHeight]
            },
            getDocumentTitle: function () {
                var a = document.title;
                "string" !== typeof a && (a = (a = document.getElementsByTagName("title")) && a.length ? a[0].innerHTML : "");
                return a
            },
            isFromAd: function () {
                if (!document.referrer) {
                    return false;
                }

                var adSystemSources = ['adfox', 'admitad', 'adnews', 'adnous', 'adriver', 'advmaker', 'aport', 'aport.ru', 'AvitoPromo', 'AvitoContext', 'begun', 'bing', 'B2BContext', 'criteo', 'directadvert', 'directadvert.ru', 'drivenetwork', 'facebook', 'fb', 'facebook.com', 'fb.com', 'giraffio', 'google', 'adwords', 'adsense', 'instagram', 'kavanga', 'ladycenter', 'link', 'magna', 'marketgid', 'medialand', 'merchant', 'moimir', 'nnn', 'nnn.ru', 'odnoklassniki', 'price', 'price.ru', 'prre', 'mytarget', 'targetmailru', 'taboola', 'torg.mail.ru', 'trorer', 'rorer', 'Ttarget', 'ubn.ua', 'banner.ua', 'videonow', 'vkontakte', 'vk', 'vk.com', 'whisla', 'youtube'];
                var adSystemMediums = ["cpc", "ppc", "paidsearch", "cpv", "cpa", "cpp", "display", "cpm", "banner"];

                var queryParams = window.location.search.replace("?", "").split('&');
                var hashParams = window.location.hash.replace("#", "").split('&');
                var params = hashParams.concat(queryParams);

                var isAd = false;
                params.forEach(function (item) {
                    var p = item.split("=");
                    if (p[0] === "utm_source" && p[1] && adSystemSources.indexOf(p[1])) {
                        return isAd = true;
                    }
                    if (p[0] === "utm_medium" && p[1] && adSystemMediums.indexOf(p[1])) {
                        return isAd = true;
                    }
                });

                return isAd;
            },
            extractHostname: function (url) {
                if (url === undefined || url === '') {
                    return '';
                }
                var hostname;

                //find & remove protocol (http, ftp, etc.) and get hostname
                if (url.indexOf("://") > -1) {
                    hostname = url.split('/')[2];
                } else {
                    hostname = url.split('/')[0];
                }

                //find & remove port number
                hostname = hostname.split(':')[0];
                //find & remove "?"
                hostname = hostname.split('?')[0];
                hostname = hostname.replace(/^www\./, '');
                hostname = hostname.replace('#', '');

                return hostname;
            },
            isExternal: function (linkUrl) {
                var hostname = this.extractHostname(linkUrl);
                if (Array.isArray(Config.siteDomains)) {
                    if (Config.siteDomains.indexOf(hostname) > -1 || hostname === '') {
                        return false;
                    }
                } else {
                    return !(this.extractHostname(window.location.hostname) === hostname || hostname === '')
                }
                return true;
            },
            isInternal: function (linkUrl) {
                var hostname = this.extractHostname(linkUrl);
                var currHostname = this.extractHostname(window.location.hostname);
                if (currHostname === hostname) {
                    return false;
                }
                if (Array.isArray(Config.siteDomains)) {
                    if (Config.siteDomains.indexOf(hostname) > -1 || hostname === '') {
                        return true;
                    }
                } else {
                    return true;
                }
                return false;
            }
        };

        var Request = {
            send: function (url, data) {
                url === Config.hitUrl && (data.ident = this.prepareBrowserInfo());
                if (Config.xsollauid && url.indexOf('_xm') === -1) {
                    var param = '_xm=' + Config.xsollauid;
                    url = url.indexOf('?') === -1 ? url + '?' + param : url + '&' + param;
                }
                var body = typeof data !== 'string' ? JSON.stringify(data) : data;
                if (!Config.xsollauid && Config.hitCount === 0) {
                    Config.hitCount = 1;
                    this.sendXHR(url, body);
                } else if (!Config.xsollauid && Config.hitCount === 1) {
                    setTimeout(function () {
                        Config.hitCount = 2;
                        Request.send(url, data);
                    }, 1000);
                } else if (!this.sendBeacon(url, body)) {
                    this.sendXHR(url, body)
                }
            },
            sendUserParams: function (data) {
                data.clid = Config.clientId;
                data.cid = Config.counterId;
                var body = JSON.stringify(data);
                var url = Config.userParamsUrl;
                if (!this.sendBeacon(url, body)) {
                    this.sendXHR(url, body)
                }
            },

            sendBeacon: function (url, body) {
                if ("function" === typeof navigator.sendBeacon && navigator.onLine) {
                    navigator.sendBeacon(url, body);
                    return true;
                }
                return false;
            },
            sendXHR: function (url, body) {
                if (window.XMLHttpRequest) {
                    var xhr = new XMLHttpRequest;
                    try {
                        xhr.open("POST", url, true)
                    } catch (e) {
                        return false
                    }
                    xhr.timeout = 10000;
                    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                    xhr.withCredentials = true;
                    xhr.ontimeout = function () {
                        Request.sendXHR(url, body);
                    };
                    xhr.onload = function () {
                        var xsollauidFromUrl = Request.getValueFromUrl(xhr.responseURL, '_xm');
                        if (xsollauidFromUrl && xsollauidFromUrl !== Config.xsollauid) {
                            Config.xsollauid = Cookies.getXsollauid(xsollauidFromUrl);
                        } else {
                            var xsollauidFromBody = Request.getValueFromBody(xhr.responseText, 'xsollauid');
                            if (xsollauidFromBody && xsollauidFromBody !== Config.xsollauid) {
                                Config.xsollauid = Cookies.getXsollauid(xsollauidFromBody);
                            }
                        }
                    };
                    xhr.send(body);
                    return true;
                }
                return false;
            },
            getValueFromUrl: function (url, key) {
                if (url && url.indexOf(key + '=') > -1) {
                    var regexp = new RegExp('https?:\/\/.*' + key + '=([^&]*)');
                    var valueFromURL = url.match(regexp);
                    if (valueFromURL && valueFromURL.length > 1) {
                        return valueFromURL[1];
                    }
                }
                return null;
            },
            getValueFromBody: function (body, key) {
                try {
                    var valueFromBody = body ? JSON.parse(body)[key] : null;
                } catch (e) {
                    valueFromBody = null;
                }
                return valueFromBody;
            },
            setXsollauidFromUrl: function (url) {
                var params = Request.getValueFromUrl(url, '_xm');
                if (params) {
                    params = params.split('.');
                    if (params && params.length === 2 && params[0] === '' + Config.counterId && params[1] !== Config.xsollauid) {
                        Config.xsollauid = Cookies.getXsollauid(params[1]);
                    }
                } else {
                    params = Request.getValueFromUrl(url, '_xsollauid');
                    if (params && params !== Config.xsollauid) {
                        Config.xsollauid = Cookies.getXsollauid(params);
                    }
                }
            },
            prepareBrowserInfo: function () {
                var p = {};
                var screen = window.screen;

                var ntf = Browser.getNotificationPermission();
                ntf !== "" && (p.ntf = ntf);
                var net = Browser.netType();
                net !== "" && (p.net = net);

                p.t = Document.getDocumentTitle();
                p.pc = Document.getDocumentCharset();
                p.tz = Time.getTimezone();

                var vs = Document.getViewportSize();
                p.wcw = vs[0];
                p.wch = vs[1];

                p.plt = Browser.firstContentfulPaintTime();
                p.lcp = Config.sendLoadMetrics ? LCP : 0;

                p.la = Browser.getLanguage();
                p.j = Browser.getJavaEnabled() ? 1 : 0;

                p.clid = Config.clientId;
                p.cid = Config.counterId;
                p.vid = Cookies.getVid();
                p.c = Browser.getCookiesEnabled() ? 1 : 0;
                p.sw = screen.width;
                p.sh = screen.height;
                p.sc = screen.colorDepth || screen.pixelDepth;
                Browser.isIframe() && (p.ifr = 1);

                var yid = Cookies.read("_ym_uid");
                if (yid) {
                    p.yid = yid;
                }
                try {
                    var ga = Cookies.read("_ga");
                    if (ga.length > 0) {
                        ga = ga.split(".");
                        p.gaid = ga[2] + "." + ga[3];
                    }
                } catch (e) {
                }
                var pv = Cookies.read("paystation_visit");
                if (pv) {
                    p.pv = pv;
                }
                var cv = Cookies.read("corpsite_visit");
                if (cv) {
                    p.cv = cv;
                }
                var pav = Cookies.read("pa_visit");
                if (pav) {
                    p.pav = pav;
                }
                var dv = Cookies.read("dev_visit");
                if (dv) {
                    p.dv = dv;
                }
                var fvp = Cookies.read("first_visit");
                if (fvp) {
                    p.fvp = fvp;
                }
                return p
            }
        };

        var Events = {
            setHandlers: function (hit, extLink, click, scroll, sendLoadMetrics, crossDomainTracking) {
                sendLoadMetrics && this.documentVisibilityChange();
                sendLoadMetrics && this.documentReadyEvent(Browser.largestContentfulPaintTime);
                hit && this.documentReadyEvent(this.onDocumentReady);
                extLink && this.documentReadyEvent(this.clickEvent);
                click && this.documentReadyEvent(this.selectorEvent);
                scroll && this.documentReadyEvent(this.scrollEvent);
                crossDomainTracking && this.documentReadyEvent(this.externalTransitionEvent);
            },
            documentReadyEvent: function (func) {
                if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
                    func();
                } else {
                    document.addEventListener('DOMContentLoaded', func);
                }
            },
            documentVisibilityChange: function () {
                document.addEventListener('visibilitychange', function fn(e) {
                    if (document.visibilityState === 'hidden') {
                        firstHiddenTime = Math.min(firstHiddenTime, Math.round(e.timeStamp));
                        document.removeEventListener('visibilitychange', fn);
                    }
                });
            },
            clickEvent: function () {
                var Anchors = document.getElementsByTagName("a");
                for (var i = 0; i < Anchors.length; i++) {
                    if (!Anchors[i].eventOnClickIsAssigned) {
                        Anchors[i].eventOnClickIsAssigned = true;
                        Events.setEvents(Anchors[i], "click", Events.onClick);
                    }
                }
            },
            setEvents: function (el, eventType, func) {
                el.addEventListener ? el.addEventListener(eventType, func) : el.attachEvent && el.attachEvent("on" + eventType, func)
            },
            onDocumentReady: function () {
                var url = window.location.href;
                var data = {
                    et: 1,
                    url: url,
                    eid: Config.externalId,
                    exv: Config.extraValues,
                    abParams: Config.abParams
                };

                // не нужно отправлять редирект с дефолтным merchant_id
                if (data.eid && data.eid === 2340) {
                    return
                }

                if (document.referrer) {
                    data.referer = document.referrer;
                    if (!Document.isExternal(data.referer)) {
                        data.ss = 1
                    }
                    Request.setXsollauidFromUrl(url);
                }
                Request.send(Config.hitUrl, data)
            },
            onClick: function () {
                if (Document.isExternal(this.href)) {
                    Request.send(Config.hitUrl, {
                        et: 2,
                        referer: window.location.href,
                        url: this.href,
                        eid: Config.externalId,
                        exv: Config.extraValues,
                        abParams: Config.abParams
                    });
                }
            },
            selectorEvent: function () {
                var Anchors = document.querySelectorAll("[data-analytics]");
                for (var i = 0; i < Anchors.length; i++) {
                    Events.setEvents(Anchors[i], "click", Events.onSelectorClick)
                }
            },
            onSelectorClick: function () {
                Request.send(Config.hitUrl, {
                    et: 3,
                    en: this.dataset.analytics,
                    url: window.location.href,
                    eid: Config.externalId,
                    exv: Config.extraValues,
                    abParams: Config.abParams
                })
            },
            scrollEvent: function () {
                Events.setEvents(window, "scroll", Events.onScroll)
            },
            onScroll: function () {
                if (ScrollTimer !== null) {
                    clearTimeout(ScrollTimer);
                }
                ScrollTimer = setTimeout(function () {
                    // отправляем скролл только если страница не помещается в экран
                    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                    var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
                    if (!ScrollFirst && scrollTop > 0) {
                        ScrollFirst = true;
                        Request.send(Config.hitUrl, {
                            et: 10,
                            url: window.location.href,
                            eid: Config.externalId,
                            exv: Config.extraValues,
                            abParams: Config.abParams
                        })
                    }
                    if (!ScrollMiddle && 2 * scrollTop > (scrollHeight - document.documentElement.clientHeight)) {
                        ScrollMiddle = true;
                        Request.send(Config.hitUrl, {
                            et: 11,
                            url: window.location.href,
                            eid: Config.externalId,
                            exv: Config.extraValues,
                            abParams: Config.abParams
                        })
                    }
                    if (!ScrollBottom && scrollTop >= (scrollHeight - document.documentElement.clientHeight) * 0.9) {
                        ScrollBottom = true;
                        Request.send(Config.hitUrl, {
                            et: 12,
                            url: window.location.href,
                            eid: Config.externalId,
                            exv: Config.extraValues,
                            abParams: Config.abParams
                        });
                    }


                }, 150);
            },
            onFormSubmit: function () {
            },
            externalTransitionEvent: function () {
                Events.setEvents(document, "mousedown", Events.onExternalTransition);
                Events.setEvents(document, "keyup", Events.onExternalTransition);
            },
            onExternalTransition: function (e) {
                e = e || window.event;
                a: {
                    var trg = e.target || e.srcElement;
                    for (e = 100; trg && 0 < e;) {
                        if (trg.href && trg.nodeName.match(/^a(?:rea)?$/i)) {
                            var l = trg;
                            break a
                        }
                        trg = trg.parentNode;
                        e--
                    }
                    l = {}
                }
                if (("http:" === l.protocol || "https:" === l.protocol) && l.href && Document.isInternal(l.href)) {
                    if (!(l.href.indexOf('_xm=') > -1) && Config.xsollauid && Config.counterId) {
                        var newParam = '_xm=' + Config.counterId + '.' + Config.xsollauid;
                        if (l.href.indexOf('?') === -1) {
                            l.href = Util.getHrefWithAnchor(l.href, newParam, '?');
                        } else {
                            l.href = Util.getHrefWithAnchor(l.href, newParam, '&');
                        }
                    }
                }
            },
            transferDataToIframe: function () {
                if (Browser.isIframe()) {
                    var doHit = Config.hit;
                    Config.hit = false;
                    var wasHited = false;

                    var onMessageFromMainPage = function (e) {
                        var dataFromMainPage = Util.parseData(e.data);
                        if (!dataFromMainPage.vid) {
                            return;
                        }
                        window.removeEventListener("message", onMessageFromMainPage);
                        Config.visitId = dataFromMainPage.vid;
                        Cookies.create("vid", dataFromMainPage.vid, 30);
                        if (doHit) {
                            wasHited = true;
                            Events.documentReadyEvent(Events.onDocumentReady);
                        }
                    };
                    window.addEventListener("message", onMessageFromMainPage);

                    // Отправить hit из фрейма, не ps
                    setTimeout(function () {
                        if (doHit && !wasHited) {
                            Events.documentReadyEvent(Events.onDocumentReady);
                        }
                    }, 500);
                    return;
                }

                var onMessageFromPs = function (e) {
                    var dataFromPs = Util.parseData(e.data);
                    if (!dataFromPs.command || dataFromPs.command !== "open-paystation") {
                        return;
                    }

                    var iframePs = document.querySelector("iframe[class^='xpaystation']");
                    if (!iframePs) {
                        return;
                    }

                    var data = {
                        vid: Config.visitId
                    };
                    iframePs.contentWindow.postMessage(JSON.stringify(data), "*");
                    window.removeEventListener("message", onMessageFromPs);
                };

                window.addEventListener("message", onMessageFromPs);
            }
        };

        var Api = {
            hit: function (url, obj) {
                if (!Config.isBrowser) {
                    return
                }
                var dataObj = Util.apiHelper(1, obj);
                var ref = (window.location != window.parent.location) ? document.referrer : document.location.href;
                var refererUrl = dataObj && dataObj.referer ? dataObj.referer : ref;
                dataObj.referer = refererUrl;
                if (dataObj.referer != document.location.href) {
                    Request.setXsollauidFromUrl(url);
                }
                dataObj.url = url;
                Request.send(Config.hitUrl, dataObj)
            },
            externalLink: function (url, obj) {
                if (!Config.isBrowser) {
                    return
                }
                var dataObj = Util.apiHelper(2, obj);
                dataObj.referer = window.location.href;
                dataObj.url = url;
                Request.send(Config.hitUrl, dataObj);
            },
            elementClick: function (name, obj) {
                if (!Config.isBrowser) {
                    return
                }
                var dataObj = Util.apiHelper(3, obj);
                dataObj.url = window.location.href;
                dataObj.en = name;
                Request.send(Config.hitUrl, dataObj);
            },
            formData: function (name, formData, obj) {
                if (!Config.isBrowser) {
                    return
                }
                var dataObj = Util.apiHelper(4, obj);
                dataObj.url = window.location.href;
                var formDataStr = formData ? JSON.stringify(formData) : "";
                dataObj.form = formDataStr;
                dataObj.en = name;
                Request.send(Config.hitUrl, dataObj);
            },
            customEvent: function (name, obj) {
                if (!Config.isBrowser) {
                    return
                }
                var dataObj = Util.apiHelper(5, obj);
                dataObj.url = window.location.href;
                dataObj.en = name;
                Request.send(Config.hitUrl, dataObj);
            },
            eventForLCP: function () {
                if (!Config.isBrowser) {
                    return
                }
                var dataObj = {
                    et: 6,
                    url: window.location.href
                };
                Request.send(Config.hitUrl, dataObj);
            },
            setABParams: function (obj) {
                if (!Config.isBrowser) {
                    return
                }
                Config.abParams = typeof obj === 'object' ? JSON.stringify(obj) : "";
            },
            setUserParams: function (obj) {
                var dataObj = typeof obj != 'object' ? "" : {uprm: obj};
                dataObj && Request.sendUserParams(dataObj);
            },
            addXsollauidToUrl: function (url) {
                if (url.indexOf('_xsollauid\x3d') > -1) {
                    return url
                }
                var xuid = Cookies.getXsollauid();
                var xuidParam = xuid ? '_xsollauid\x3d' + xuid : '';
                var newUrl = xuidParam ? (url.indexOf('?') !== -1 ? url + '&' + xuidParam : url + '?' + xuidParam) : url;
                return newUrl
            },
            sendCustomData: function (route, data) {
                var url = route ? Config.server + '/' + route : "";
                var xuidParam = Config.xsollauid ? '_xm\x3d' + Config.xsollauid : '';
                url = xuidParam ? (url.indexOf('?') !== -1 ? url + '&' + xuidParam : url + '?' + xuidParam) : url;
                url && Request.send(url, data);
            }
        };

        Config.counterId = params.id;
        Config.siteDomains = params.siteDomains;
        var server = params.server.match(/(https?:\/\/[^\/]*)/g);
        Config.server = server && server.length ? server[0] : console.log('Не удалось извлечь адрес сервера! Установлено значение по умолчанию - https://datagather.xsolla.com') || 'https://datagather.xsolla.com';
        Config.hitUrl = Config.server + '/hit';
        Config.userParamsUrl = Config.server + '/users_params';
        Config.externalId = params.externalId || params.merchantId;
        Config.extraValues = params.extraValues ? JSON.stringify(params.extraValues) : "";
        Config.hit = typeof params.hit != "undefined" ? params.hit : true;
        Config.extLink = typeof params.extLink != "undefined" ? params.extLink : true;
        Config.click = typeof params.click != "undefined" ? params.click : true;
        Config.scroll = typeof params.scroll != "undefined" ? params.scroll : true;
        Config.sendLoadMetrics = typeof params.sendLoadMetrics != "undefined" ? params.sendLoadMetrics : false;
        Config.crossDomainTracking = typeof params.crossDomainTracking != "undefined" ? params.crossDomainTracking : true;
        if (Config.isBrowser) {
            Config.clientId = Cookies.getUid();
            Config.visitId = Cookies.getVid();
            Events.transferDataToIframe();
            Config.xsollauid = params.xsollauid || Cookies.getXsollauid();
            params.abParams && Api.setABParams(params.abParams);
            Config.server && Config.counterId && Events.setHandlers(Config.hit, Config.extLink, Config.click, Config.scroll, Config.sendLoadMetrics, Config.crossDomainTracking);
            params.userParams && Api.setUserParams(params.userParams);
        }
        return Api;
    };

    if (typeof window !== 'undefined') {
        window.XsollaAnalytics = XsollaAnalytics;
    } else {
        module.exports = XsollaAnalytics;
    }
})();
